import BookingAttachmentCard from './BookingAttachmentCard';

export default BookingAttachmentCard;
